/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import {lazy, Suspense} from 'react';
import { Route, Routes } from 'react-router-dom';
import Loader from './components/atoms/loader.component';
import NotificationHoc from './hoc/notification.hoc';

const HomePage = lazy(() => import('./components/pages/home.page'));
const ListPage = lazy(() => import('./components/pages/list.page'));
const CreatePage = lazy(() => import('./components/pages/create.page'));
const EditPage = lazy(() => import('./components/pages/edit.page'));
const PreviewPage = lazy(() => import('./components/pages/preview.page'));

function App() {
  return (
    <>
      <NotificationHoc>
        <Suspense fallback={<Loader fullPage text="Cargando" />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/roles" element={<ListPage />} />
            {<Route path="/roles/create" element={<CreatePage />} />}
            <Route path="/roles/preview/:service/:license/:rol" element={<PreviewPage />} />
            <Route path="/roles/edit/:service/:license/:rol" element={<EditPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </Suspense>
      </NotificationHoc>
    </>
  );
}

export default App;
